// components
import { styled, Button, ButtonProps, Box, BoxProps } from '@mui/material';

export const StyledRTEButton = styled(Button)<ButtonProps>(({ theme }) => ({
  width: '32px',
  height: '32px',
  minWidth: '32px',
  backgroundColor: theme.palette.common.white,
  boxShadow: 'none',
  padding: 0,
  margin: 0,
  borderRadius: '4px',
  color: theme.palette.text.primary,

  '&:hover': {
    backgroundColor: theme.palette.divider,
    boxShadow: 'none'
  },

  '&:disabled': {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.action.disabled
  },

  '&.is-active': {
    backgroundColor: theme.palette.divider,
    color: theme.palette.text.primary
  }
}));

export const StyledToolsBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  paddingBottom: theme.spacing(4),
  gap: theme.spacing(2),
  marginBottom: theme.spacing(1)
}));

export const StyledEditorContentContainer = styled(Box)<BoxProps>(
  ({ theme }) => ({
    minHeight: 160,
    padding: theme.spacing(4),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(-1),
    backgroundColor: theme.vars.palette.grey[50],
    borderBottomLeftRadius: '16px',
    borderBottomRightRadius: '16px',
    border: `1px solid ${theme.palette.divider}`,

    '& p': {
      margin: theme.spacing(0, 0, 2, 0)
    },

    '& p:last-child': {
      margin: theme.spacing(0)
    },

    '& table': {
      margin: theme.spacing(4, 0),
      borderTop: `1px dashed ${theme.palette.divider}`,
      borderBottom: `1px dashed ${theme.palette.divider}`,
      padding: theme.spacing(3, 0),

      '& tr td p': {
        padding: theme.spacing(0, 2, 0, 0)
      }
    },

    '& .ProseMirror-trailingBreak': {
      display: 'none'
    }
  })
);
export const StyledWordCountContainer = styled(Box)<BoxProps>(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  right: 0,
  padding: theme.spacing(2, 4),
  backgroundColor: theme.palette.background.paper,
  borderTop: '1px solid',
  borderLeft: '1px solid',
  borderColor: theme.palette.divider,
  borderTopLeftRadius: theme.shape.borderRadius,
  color: theme.palette.success.main,

  '&.character-count--warning': {
    color: theme.palette.error.main
  }
}));

export const StyledCustomRichTextSaveButton = styled(Button)<ButtonProps>(
  ({ theme }) => ({
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  })
);
